import { css } from 'lit';

export const styles = css`:host{--value-label: var(--ig-rating-value-label, var(--ig-gray-700));--ig-theme: material}`;
